import React from "react"
import BeatLoader from "react-spinners/BeatLoader"

export default function Loader({ loading = true }) {
  return (
    <div className="row d-flex justify-content-center align-items-center">
      <BeatLoader color="#213F7A" loading={loading} />
    </div>
  )
}